<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
       
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="ApplyFee">
                            <!--  -->
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div>
                                            <div class=" d-flex align-items-center pl-3">
                                                <img alt="Logo" src="../../assets/img/purse.png"
                                                    class="mh-45px pb-2">
                                                <div class="ml-2">
                                                    <h3 class="main-content-label mb-1"><b>
                                                        Apply Admission Fee
                                                        </b></h3>
                                                    <p class="text-muted card-sub-title mb-0">
                                                        List Of Admission Fee
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width" >
                                                            <mat-label>Session</mat-label>
                                                            <mat-select #select232 placeholder="Session" class="colorblack"
                                                                formControlName="SessionId">
                                                                <mat-select-filter *ngIf="select232.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                    [array]="sessionList"
                                                                    (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                                <mat-option *ngFor="let item of SessionFilterList"
                                                                    [value]="item.SnNo" (click)="getCourse(item.SnNo)">
                                                                    {{item.SnName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>
                                                                Course
                                                            </mat-label>
                                                            <mat-select #select55 class="colorblack"
                                                                formControlName="course" [displayMember]="'CoName'">
                                                                <mat-select-filter *ngIf="select55.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                    [array]="CourseList"
                                                                    (filteredReturn)="filteredListCourse =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredListCourse"
                                                                    [value]="item.CoCgCoCode" (click)="getClg(item.CoCgCoCode)">
                                                                    {{item.CoCgCoCode}} - {{item.CoName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <div class="">
                                                        <mat-form-field appearance="outline" class="example-full-width">
                                                            <mat-label>
                                                                College
                                                            </mat-label>
                                                            <mat-select #select23 placeholder="CoCode"
                                                                formControlName="college" [displayMember]="'CgName'">
                                                                <mat-select-filter *ngIf="select23.focused"
                                                                    [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                    [array]="collegeList"
                                                                    (filteredReturn)="filteredCollegeList =$event">
                                                                </mat-select-filter>
                                                                <mat-option *ngFor="let item of filteredCollegeList"
                                                                    [value]="item.CgCode" (click)="ShowTable(item.CgCode)">
                                                                    {{item.CgCode}} - {{item.CgName}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div *ngIf="Table" class="table-responsive table-container tab mt-1">
                                                <table id="datatable"
                                                    class="table table-bordered text-nowrap text-left">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                Student Name
                                                            </th>
                                                            <th class="f600">
                                                                Template Name
                                                            </th>
                                                            <th class="f600">
                                                                Admission Mode
                                                            </th>
                                                            <th   width="20%"   class="f600 text-center">Action</th>
                                                            <th wiidth="20%"  *ngIf="PayStatus" class="f600 text-center">Receipt</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="feeApplyArray">
                                                        <tr *ngFor="let fee of getfeeApplyArrayControls(); let i = index; let last = last; let item of FeeTable "
                                                                [formGroupName]="i">
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="StudentName" readonly>
                                                            </td>
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="TemplateName" readonly>
                                                            </td>
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="StuAdm" readonly>
                                                            </td>
                                                            <td class="text-center">
                                                                <ng-container *ngIf="!PayStatus[i] && !Paylater[i]">
                                                                    <button type="button" class="btn sz btn-primary btn-icon-text  mt-1 fr" (click)="checkLock2(item)">
                                                                        <span style="display: contents; align-items: center;">
                                                                            <img width="20vh" src="../../assets/img/pay-per-click.gif" style="margin-right: 5px;"> Pay
                                                                        </span>
                                                                    </button>
                                                                </ng-container>
                                                                <ng-container *ngIf="PayStatus[i]">
                                                                    <h3 class="main-content-label mb-1"  (click)="checkLock2(item)" >
                                                                        <!-- (click)="checkLock2(item)" -->
                                                                        <b>{{FeePaid}}</b>
                                                                    </h3>
                                                                </ng-container>
                                                                <ng-container *ngIf="Paylater[i]">
                                                                    <h3 class="main-content-label mb-1">
                                                                        <b>Pay Later</b>
                                                                    </h3>
                                                                </ng-container>
                                                                
                                                            </td>
                                                            <td  class="text-center" *ngIf="PayStatus[i]">
                                                                <h3  (click)="paymentReceipt(item)"  class="main-content-label mb-1" >
                                                                    <!-- (click)="paymentReceipt(item)" -->
                                                                    <b > Payment Status</b>
                                                                </h3>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>